import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

/** Contains states, helpers and event listeners related to roster print functionality  */
export const useRosterGuestListForPrint = () => {
    const history = useHistory();
    const location = useLocation<{ print?: boolean }>();
    const print = location.state?.print ?? false;
    const [isPrintRosterGuestListVisible, setIsPrintRosterGuestListVisible] = useState<boolean>(print);

    const showPrintRosterGuestList = () => setIsPrintRosterGuestListVisible(true);

    const hidePrintRosterGuestList = () => setIsPrintRosterGuestListVisible(false);

    const handleAfterPrint = () => {
        hidePrintRosterGuestList();
        history.replace(location.pathname, { ...location.state, print: false });
    };

    useEffect(() => {
        window.addEventListener("beforeprint", showPrintRosterGuestList);
        window.addEventListener("afterprint", handleAfterPrint);

        return () => {
            window.removeEventListener("beforeprint", showPrintRosterGuestList);
            window.removeEventListener("afterprint", handleAfterPrint);
        };
    }, []);

    return {
        isPrintRosterGuestListVisible,
        showPrintRosterGuestList,
    };
};
